export default __webpack_public_path__ + "static/media/muted.a401896f.svg";